module.exports = __webpack_public_path__ + "d80476f842ca5aae2aa524e579df272d.MP3";